<ng-container *transloco="let t">
<!-- Desktop: original card layout -->
<div class="card desktop-loan-contacts">
  <div class="card-header d-flex align-items-center justify-content-center"
    style="min-height: 50px;padding-top: 6px;">
    <h5 class="opacity-80">{{ t('portal.contacts.title') }}</h5>
  </div>
  <div class="card-body p-1">
    @for (contact of borrowerContact.loanContacts | filter: 'userId' | sort: 'order'; track contact.userId) {
      <div class="row g-0 py-2">
        <div class="col-3 d-flex align-items-center justify-content-center">
          @if (!contact.avatarUrl) {
            <span
              class="bp-contact-name-circle p-2 rounded-circle fw-bold d-flex align-items-center justify-content-center">
              {{ contact.name?.charAt(0) }}
            </span>
          }
          @if (contact.avatarUrl) {
            <person-circle-image [url]="contact.avatarUrl" [size]="60"></person-circle-image>
          }
        </div>
        <div class="col-9">
          <div class="opacity-80 fw-bold" style="font-size:12px">{{ contact.name }}</div>
          <div class="text-muted" style="font-size:12px">{{ contact.title }}</div>
          @if (contact.userId) {
            <div class="d-flex flex-column" style="word-break: break-all">
                <a class="nav-link d-inline p-0 mt-1 mb-1" style="font-size:10px" href="tel:{{ contact.phone }}"
                  [ngClass]="!contact.phone ? 'disabled' : ''"><i class="fa fa-phone"></i> {{ contact.phone | phone }}</a>

                <a class="nav-link d-inline p-0 mb-1" style="font-size:10px" [ngClass]="!contact.email ? 'disabled' : ''"
                  href="mailto: {{ contact.email }}"><i class="fa fa-envelope"></i> {{ contact.email }}</a>
                @if (contact?.calendarLink) {
                  <a class="nav-link d-inline p-0 mb-1" style="font-size:10px" [href]="contact?.calendarLink"
                    target="_blank"><i class="fa fa-calendar"></i> {{ t('portal.contacts.viewCalendar') }}
                  </a>
                }
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>

<!-- Mobile: native-style contact cards without container or header -->
<div class="mobile-loan-contacts d-none">
  @for (contact of borrowerContact.loanContacts | filter: 'userId' | sort: 'order'; track contact.userId) {
    <div class="mobile-contact-item">
      <div class="mobile-contact-avatar">
        @if (!contact.avatarUrl) {
          <span class="mobile-contact-initials">
            {{ contact.name?.charAt(0) }}
          </span>
        }
        @if (contact.avatarUrl) {
          <person-circle-image [url]="contact.avatarUrl" [size]="40"></person-circle-image>
        }
      </div>
      <div class="mobile-contact-info">
        <span class="mobile-contact-name">{{ contact.name }}</span>
        <span class="mobile-contact-title">{{ contact.title }}</span>
      </div>
      @if (contact.userId) {
        <div class="mobile-contact-actions">
          @if (contact.phone) {
            <a href="tel:{{ contact.phone }}" class="mobile-contact-action-btn" title="Call">
              <i class="fa fa-phone"></i>
            </a>
          }
          @if (contact.email) {
            <a href="mailto:{{ contact.email }}" class="mobile-contact-action-btn" title="Email">
              <i class="fa fa-envelope"></i>
            </a>
          }
          @if (contact?.calendarLink) {
            <a [href]="contact?.calendarLink" target="_blank" class="mobile-contact-action-btn" title="Calendar">
              <i class="fa fa-calendar"></i>
            </a>
          }
        </div>
      }
    </div>
  }
</div>
</ng-container>
